import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../../styles/Navbar.scss";
import logo from "../../assets/logo.png";
import { MdFavorite, MdMenu } from "react-icons/md";
import { IoTicket } from "react-icons/io5";
import NavMenu from "./NavMenu";
import { getTokenOrDefault } from "../../helpers/Storage";
import { useSessionContext } from "../../security/context/SessionContext";


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
	const location = useLocation();
  const { session } = useSessionContext();

  const TicketIcon = IoTicket as React.ElementType;
  const FavoriteIcon = MdFavorite as React.ElementType;
  const MenuIcon = MdMenu as React.ElementType;

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo-link">
            <img src={logo} alt="Gottix Logo" />
          </Link>
        </div>
        <div className="navbar-icons">
           {session.isAuthenticated ? (
            <>
              <Link to="/tickets">
                <TicketIcon className="nav-icon" size={24} />
              </Link>
              {/* <FavoriteIcon className="nav-icon" size={24} /> */}
            </>
          ) : (
            <Link to="/sec/log-in" className="login-btn">
              Log In
            </Link>
          )}
          <MenuIcon
            className="nav-icon menu-icon"
            size={24}
            onClick={() => setMenuOpen((prev) => !prev)}
          />
        </div>
      </nav>

      <NavMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
};

export default Navbar;
